import { Lock } from 'lucide-react';
import { cn } from '../utils/cn';

interface ConfidentialEvidencePlaceholderProps {
  className?: string;
  /** Compact mode hides the text label, showing only the icon */
  compact?: boolean;
}

/**
 * Placeholder shown in place of real evidence content when the evidence is
 * confidential and the current user doesn't have permission to view it.
 */
export const ConfidentialEvidencePlaceholder = ({ className, compact = false }: ConfidentialEvidencePlaceholderProps) => {
  return (
    <div
      className={cn(
        'w-full h-full flex flex-col items-center justify-center gap-1.5 p-2 text-center',
        'bg-amber-500/[0.06] border border-amber-500/15',
        'select-none pointer-events-none',
        className,
      )}
    >
      <span className={cn('icon-tile icon-tile-amber', compact && 'icon-tile-sm')}>
        <Lock className={compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
      </span>
      {!compact && (
        <>
          <span className="eyebrow text-amber-400">
            Confidential
          </span>
          <span className="text-[11px] text-glass-400 leading-tight">
            You do not have access
          </span>
        </>
      )}
    </div>
  );
};
